export default __webpack_public_path__ + "static/media/blue-help.b835a093.svg";